import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { disputesApi } from '../api/disputesApi';
import { useToast } from '../../../shared/components/toast/useToast';

const errMsg = (err: unknown, fallback: string) => ((err as Error)?.message) || fallback;

export const useDisputes = (status?: string) =>
  useQuery({
    queryKey: ['disputes', status ?? 'all'],
    queryFn: () => disputesApi.list(status),
    staleTime: 60 * 1000,
  });

export const useClawbacks = () =>
  useQuery({
    queryKey: ['disputes', 'clawbacks'],
    queryFn: disputesApi.clawbacks,
    staleTime: 60 * 1000,
  });

export const useRefundPayment = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  return useMutation({
    mutationFn: ({ reference, amount }: { reference: string; amount?: number }) =>
      disputesApi.refund(reference, amount),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['disputes'] });
      toast.success('Refund initiated');
    },
    onError: (err: unknown) => toast.error(errMsg(err, 'Failed to refund payment')),
  });
};
